//百果园
import Overview from './overview.vue';
import MobFull from './mob-full.vue';

export const componentMap = {
	overview: Overview,
	'mob-full': MobFull
}; 